import { useSyncExternalStore } from "react";
import { isSessionGone, onApiError } from "./api";

// Whether the session ended while the portal thought it was signed in (H-g04): after 8 hours, or because
// a new password or a reset ended it elsewhere. Then a modal says so, instead of a page that jumps to
// the sign-in under someone's hands. Every refusal of WLX comes by here (lib/api.ts).

let signedIn = false;
let lost = false;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

export const session = {
  /** The portal shell has a session: from now on a 401 means it ended. */
  started() {
    signedIn = true;
    if (lost) {
      lost = false;
      emit();
    }
  },
  /** Signed out on purpose, or on a page before signing in. */
  ended() {
    signedIn = false;
    if (lost) {
      lost = false;
      emit();
    }
  },
  report(err: unknown) {
    if (signedIn && !lost && isSessionGone(err)) {
      lost = true;
      emit();
    }
  },
};

export function useSessionLost(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => lost,
  );
}

onApiError((err) => session.report(err));
